<template>
  <div :class="`invite-page ${types.length === 1 ? 'invite-page-fix' : ''}`">
    <div class="close" @click="close">
      <van-icon name="cross" />
    </div>
    <div class="card-cont" ref="imageWrapper" :class="'type' + selcetType">
      <div class="user-box">
        <div class="photo" id="photo">
          <img :src="photoImg" alt="" />
        </div>
        <h4>{{ user.nickname }}</h4>
      </div>
      <div class="cont-box">
        <div class="small-tit">
          <b>{{ data.cardSummary || '邀请您来看直播' }}</b>
        </div>
        <h3 class="title">{{ roomTitle }}</h3>
        <!-- <h5>直播时间：{{ data.cardFooter }}</h5> -->
        <h5>直播时间：{{ liveStartTime || roomData.liveStartTime }}</h5>
        <div class="cover-img">
          <img :src="data.coverImage || roomData.liveImage" />
        </div>
      </div>
      <div class="ercode-box">
        <img v-if="data.inviteCardQr" :src="data.inviteCardQr || defaultImg" />
        <vue-qr v-else :margin="0" :text="qrUrl" :size="100"></vue-qr>
        <h4>长按识别二维码立即进入<br />{{ data.cardFooter }}</h4>
      </div>
      <img class="card-bg" :src="typeImg" />
    </div>

    <div v-if="types.length > 1" class="type-list">
      <h2>
        <a v-if="hasShare" @click="shareInviteImage">点击分享邀请卡</a>
        <span v-else>长按保存邀请卡，分享好友一起看直播</span>
      </h2>
      <van-radio-group v-model="selcetType">
        <van-radio v-for="item in types" :key="item.id" :name="item.id" @click="changeType(item)">
          <img :src="item.image" />
        </van-radio>
      </van-radio-group>
      <h4>请选择您的直播分享邀请卡</h4>
    </div>
    <h2
      v-else
      :style="{
        position: 'absolute',
        bottom: '24px',
        left: 0
      }"
    >
      <a v-if="hasShare" @click="shareInviteImage">点击分享邀请卡</a>
      <span v-else>长按保存邀请卡，分享好友一起看直播</span>
    </h2>
  </div>
</template>
<script>
import axios from 'axios';
import html2canvas from 'html2canvas';
import vueQr from 'vue-qr';
export default {
  name: 'Invite',
  components: {
    vueQr
  },
  data() {
    return {
      alertText: '',
      defaultImg: require('@/assets/images/default-image.png'),
      typeImg: require('@/assets/images/card-bg.png'),
      selcetType: '',
      user: {
        headImg: '',
        nickname: ''
      },
      photoImg: require('@/assets/images/default-image.png'),
      types: [
        {
          id: '1',
          image: require('@/assets/images/card-bg.png')
        }
        // {
        //   id: '2',
        //   image: require('@/assets/images/card-bg2.png')
        // },
        // {
        //   id: '3',
        //   image: require('@/assets/images/card-bg3.png')
        // },
        // {
        //   id: '4',
        //   image: require('@/assets/images/card-bg4.png')
        // }
      ],
      liveStartTime: $$.module.data.room.roomSettingContent.roomInfo.liveStartTime,
      api: $$.module.interview.$api,
      roomData: $$.module.data.room.roomSettingContent.roomInfo,
      qrUrl: location.href,
      roomTitle: '',
      hasShare: false
    };
  },
  props: {
    data: {
      type: Object
    }
  },
  created() {
    this.getUserIonfo();
  },
  mounted() {
    this.types =
      this.data?.inviteCardEntity?.map((card) => ({
        id: card.liveImageJson?.type || card.id,
        image: card.cardImage
      })) || [];
    if (this.types.length) {
      this.selcetType = this.types[0].id;
      this.typeImg = this.types[0].image;
    }
    if (this.roomData.roomTitle) {
      this.roomTitle = this.roomData.roomTitle.length > 26 ? this.roomData.roomTitle.substring(0, 25) + '...' : this.roomData.roomTitle;
    }
    if (this.isRmtEnv && rmt.shareImage) {
      this.hasShare = true;
    }
    if (this.isRmtEnv) {
      rmt.longTouch(() => {
        this.download();
      });
    }

    // setTimeout(() => {
    //   this.testDownload();
    // }, 2000);
  },
  computed: {
    isRmtEnv() {
      return window.navigator.userAgent.indexOf('Rmt') > -1 && rmt;
    }
  },
  methods: {
    testDownload() {
      this.toImage().then((url) => {
        this.aDownload({
          url: url,
          name: 'test'
        });
      });
    },
    aDownload({ url, name }) {
      const a = document.createElement('a'); //创建一个标签
      // 七牛文件 attname控制下载文件名称
      a.href = url; // 给a标签的href属性值加上地址，注意，这里是绝对路径，不用加 点.
      a.download = name; //设置下载文件文件名，这里加上.xlsx指定文件类型，pdf文件就指定.fpd即可
      a.style.display = 'none'; // 障眼法藏起来a标签
      document.body.appendChild(a); // 将a标签追加到文档对象中
      a.click(); // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
      a.remove(); // 一次性的，用完就删除a标签
    },
    getUserIonfo() {
      if (this.isRmtEnv) {
        rmt.getAccount({
          success: (resp) => {
            let { nickname, avatar } = resp.account;
            this.user = { nickname, headImg: avatar.thumbUrl || avatar.sourceUrl };
            const image = avatar.thumbUrl || avatar.sourceUrl;
            if (/(.png|.jpg|.jpeg|.gif|.webp|.bmp|.svg)$/i.test(image)) {
              this.photoImg = image;
            } else {
              this.changeImage(image);
            }
          }
        });
      }
    },
    changeImage(img) {
      axios
        .post('/live-material-business/material/personal/smallImageFetch', {
          url: img,
          type: 1
        })
        .then((response) => {
          this.photoImg = response.data.data.url;
          // this.getTimeImg(photo)
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // getTimeImg(photo) {
    //   const that = this;
    //   var img = new Image();
    //   img.onload = function() {
    //     console.log('photo-success', photo);
    //     that.photoImg = photo;
    //   };
    //   img.onerror = function() {
    //     setTimeout(() => {
    //       that.getTimeImg(photo);
    //     }, 800);
    //   };
    //   img.src = photo;
    // },
    close() {
      this.$emit('close', true);
    },
    toImage() {
      return new Promise((resolve) => {
        html2canvas(this.$refs.imageWrapper, {
          useCORS: true
        }).then((canvas) => {
          let dataURL = canvas.toDataURL('image/png');
          resolve(dataURL);
        });
      });
    },
    changeType(data) {
      this.selcetType = data.id;
      this.typeImg = data.image;
    },
    async download() {
      if (this.isRmtEnv && this.photoImg) {
        const dataURL = await this.toImage();
        rmt.downloadImage({
          images: [
            {
              sourceUrl: dataURL
            }
          ],
          success: () => {
            this.$toast('保存成功');
          }
        });
      }
    },
    async shareInviteImage() {
      if (this.isRmtEnv) {
        const dataURL = await this.toImage();
        rmt.shareImage({
          sourceUrl: dataURL
        });
      }
    }
  }
};
</script>
